<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="payManner.pmid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="payManner"
          :rules="ruleValidate"
          class="form">
        <el-button type="primary" style="margin-bottom: 1%" @click="$refs.onSelectPayNode.open()">
          +
        </el-button>
        <pay-node-select ref="onSelectPayNode" @select="onSelectPayNode"/>
        <el-table
            :data="payMannerVOList"
            @select="selectTest"
            @select-all="selectAll">
          <el-table-column type="selection" align="center" width="55"/>
          <el-table-column prop="payNodeName" align="center" label="节点名称" width="200px"/>
          <el-table-column prop="payNodeValue" align="center" label="付款百分比">
            <template slot-scope="scope">
              <el-input v-model="scope.row.payNodeValue"/>
            </template>
          </el-table-column>
          <el-table-column align="center" label="百分号">%</el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="deleteRow(scope.$index)">
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
        <el-button type="danger" @click="onDelete">删除</el-button>
        <el-button @click="dialogVisible=false">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import PayNodeSelect from "@/views/information/PayNode/PayNodeSelect";
  export default {
    name:"PayMannerEdit",
    components: {PayNodeSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        payMannerVOList:[],
        payManner: {
          pmid: 0,
          pmNodes: "",
          pmNodesValue: "",
          isDeleted: 0,
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(id) {
        this.payManner.pmid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `payManners/${this.payManner.pmid}`)
          .then(resp => {
            this.payMannerVOList = resp[0].payNodeVO;
          });
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      onDelete() {
        for(let item of this.idList) {
          for(let i = 0;i<this.payMannerVOList.length;i++) {
            if(item.payNodeID === this.payMannerVOList[i].payNodeID) {
              this.payMannerVOList.splice(i,1);
            }
          }
        }
      },
      onSelectPayNode(row) {
        let flag = false;
        for (let item of this.payMannerVOList) {
          if (item.payNodeID === row.payNodeID) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.payMannerVOList.push({payNodeName: row.payNodeName, payNodeValue: "",payNodeID: row.payNodeID});
          console.log(this.payMannerVOList);
        } else {
          this.$message.error("不能重复添加付款节点");
        }
      },
      deleteRow(index) {
        this.$confirm("确定删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let rows = this.payMannerVOList;
          rows.splice(index, 1);
        });
      },
      handleSubmit() {
        let pmNode = [];
        let values = [];
        for(let item of this.payMannerVOList) {
          pmNode.push(item.payNodeID);
          if(item.payNodeValue === "") {
            values.push(0);
          }else{
            values.push(item.payNodeValue);
          }
        }
        this.payManner.pmNodes = pmNode.toString();
        this.payManner.pmNodesValue = values.toString();
        if(this.payManner.pmid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        console.log(this.payManner);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "payManners", this.payManner)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        console.log(this.payManner);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "payManners", this.payManner)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
